import { useLazyQuery } from '@apollo/client';
import { Dialog } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { getToken } from '../../../utils/auth';
import Nbsp from '../../shared/components/Nbsp';
import Timer from '../../shared/components/Timer';
import { useTimer } from '@shared/hooks/useTimer';
import { useClientSessionOmitter } from '@shared/hooks/useClientSessionOmitter';
import EXTEND_USER_SESSION from '../queries/extendUserSessionQuery';
import { STORAGE_KEYS, secondsToExpire } from '../services/secondsToExpireCache';
import { useGlobalReactiveVar } from '@apollo-internal/globalReactiveVar';

const COUNT_DOWN_SECONDS = 5 * 60; //5 mins

export const TimeoutWarningModal = () => {
  const [openState, setOpenState] = useState(false);
  const { endCMMISession } = useClientSessionOmitter();

  const sessionDuration = useGlobalReactiveVar(secondsToExpire, STORAGE_KEYS.SESSION_DURATION);
  const [extendSession] = useLazyQuery(EXTEND_USER_SESSION, {
    fetchPolicy: 'network-only'
  });

  const onTimerTick = useCallback(() => setOpenState(true), []);

  const { secondRemaining, resetTimer, executeWithOmittingTimer } = useTimer(
    sessionDuration?.seconds,
    COUNT_DOWN_SECONDS,
    onTimerTick,
    endCMMISession
  );

  useEffect(() => {
    if (!getToken() || !sessionDuration?.seconds) {
      return;
    }
    setOpenState(false);
    resetTimer();
  }, [sessionDuration, resetTimer]);

  return (
    <Dialog open={openState} maxWidth='md' fullWidth>
      <div data-testid='timeout-warning-modal' className='timeout-warning-modal'>
        <div className='timeout-warning-modal__content'>
          <h2 data-testid='timeout-warning-modal-header'>
            Session is expiring in
            <Nbsp />
            <Timer secondRemaining={secondRemaining} />
            <Nbsp />
            minutes.
          </h2>
          <h2>Do you want to extend your session?</h2>
          <div className='timeout-warning-modal__button-wrapper'>
            <button
              className='timeout-warning-modal__close'
              onClick={() => executeWithOmittingTimer(endCMMISession)}>
              Log Out
            </button>
            <button
              className='primary-button sm'
              onClick={() => executeWithOmittingTimer(extendSession)}>
              Yes
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default TimeoutWarningModal;
